import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithDecryption } from "../baseQueryWithEncryption";
import { get } from "http";

// const baseQuery = fetchBaseQuery({
//   baseUrl: import.meta.env.VITE_API_BASE_URL,
//   prepareHeaders: (headers) => {
//     headers.set("Content-Type", "application/json");
//     headers.set("x-api-key", import.meta.env.VITE_SUPPORT_API_KEY);
//     const token =
//       localStorage.getItem("bugtracker_accessToken") ||
//       localStorage.getItem("accessToken");
//     if (token) {
//       headers.set("accessToken", token);
//     }
//     return headers;
//   },
// });

// const jiraBaseQuery = fetchBaseQuery({
//   baseUrl: "https://test-api.day2communications.com/support-mgmt",
//   prepareHeaders: (headers) => {
//     headers.set("Content-Type", "application/json");
//     headers.set("x-api-key", import.meta.env.VITE_SUPPORT_API_KEY);
//     const token =
//       localStorage.getItem("bugtracker_accessToken") ||
//       localStorage.getItem("accessToken");
//     if (token) {
//       headers.set("accessToken", token);
//     }
//     return headers;
//   },
// });

// const jiraProjectBaseQuery = fetchBaseQuery({
//   baseUrl: import.meta.env.VITE_API_BASE_URL + "/jira-mgmt",
//   prepareHeaders: (headers) => {
//     headers.set("Content-Type", "application/json");
//     headers.set("x-api-key", import.meta.env.VITE_JIRA_MGMT_KEY);
//     const token =
//       localStorage.getItem("bugtracker_accessToken") ||
//       localStorage.getItem("accessToken");
//     if (token) {
//       headers.set("accessToken", token);
//     }
//     return headers;
//   },
// });

// const studioMgmtBaseQuery = fetchBaseQuery({
//   baseUrl: import.meta.env.VITE_STUDIO_URL,
//   prepareHeaders: (headers) => {
//     headers.set("Content-Type", "application/json");
//     headers.set("x-api-key", import.meta.env.VITE_STUDIO_KEY);
//     const token =
//       localStorage.getItem("bugtracker_accessToken") ||
//       localStorage.getItem("accessToken");
//     if (token) {
//       headers.set("accessToken", token);
//     }
//     return headers;
//   },
// });

export const supportMgmtApi = createApi({
  reducerPath: "supportMgmtApi",
  baseQuery: baseQueryWithDecryption(import.meta.env.VITE_API_BASE_URL),
  tagTypes: [
    "Bugs",
    "BugDetail",
    "Project",
    "Tags",
    "Status",
    "Comments",
    "PublicComments",
    "Filters",
    "Sprints",
    "ProjectMembers",
    "BugOccurrences",
    "Applications",
    "FeedbackWidgets",
  ],
  endpoints: (builder) => ({
    getDashboardData: builder.query({
      query: ({ bugId, projectId, subTaskId }) => ({
        url: `/project/${projectId}/dashboard`,
        params: {
          projectWiseLatest: true,
          sprintWiseLatest: true,
        },
      }),
      providesTags: ["Bugs"],
    }),
    createBug: builder.mutation({
      query: (payload) => ({
        url: "/bug",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bugs"],
    }),
    createLog: builder.mutation({
      query: (payload) => ({
        url: "/worklogs",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bugs"],
    }),
    getListOfLogs: builder.query({
      query: ({ bugId, projectId, subTaskId, userId }) => ({
        url: "/worklogs",
        params: {
          ...(bugId && { bug: bugId }),
          project: projectId,
          ...(subTaskId && { subTask: subTaskId }),
          ...(userId && { userId: userId }),
        },
      }),
      providesTags: ["Bugs"],
    }),
    updateWorkLog: builder.mutation({
      query: (payload) => ({
        url: `/worklogs/${payload.id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Bugs"],
    }),
    getListOfBugs: builder.query({
      query: ({
        search,
        sort,
        page,
        pageUrl,
        limit,
        size,
        id,
        forBoard,
        assignTo,
        tags,
        statuses,
        severities,
        createdBy,
        updatedAtStart,
        updatedAtEnd,
        dueDateStart,
        dueDateEnd,
        startDateStart,
        startDateEnd,
        isRecurring,
        project,
        type,
        isBackLog,
        sprint,
        sortType,
        viewType,
        showEpic,
        summaryDate,
        multiType,
        bugFor,
        withDetails,
        myTask,
        isFeedback,
      }) => {
        return {
          url: "/bugs",
          params: {
            ...(search && { search }),
            // ...(sort && { sortBy: sort }),
            ...(page && { page: Number(page) }),
            ...(pageUrl && { pageUrl }),
            ...(limit && { size: Number(limit) }),
            ...(size && { size: Number(size) }),
            ...(id && { project: id }),
            ...(forBoard && { forBoard }),
            ...(bugFor && { bugFor }),
            ...(assignTo && { assignTo: assignTo.join(",") }),
            ...(createdBy &&
              createdBy.length > 0 && { createdBy: createdBy.join(",") }),
            ...(tags && { tags: tags.join(",") }),
            ...(statuses && { statuses: statuses.join(",") }),
            ...(severities && { severities: severities.join(",") }),
            ...(updatedAtStart && { updatedAtStart }),
            ...(updatedAtEnd && { updatedAtEnd }),
            ...(dueDateStart && { dueDateStart }),
            ...(dueDateEnd && { dueDateEnd }),
            ...(startDateStart && { startDateStart }),
            ...(startDateEnd && { startDateEnd }),
            // My task was not working --> so we commented this. But this has stopped filter for project in my task
            ...(project !== undefined && { project: project.join(",") }),
            ...(type && { type: type.toUpperCase() }),
            ...(isRecurring && { isRecurring: true }),
            ...(isBackLog && { isBackLog: true }),
            ...(myTask && { myTask: true }),
            ...(isFeedback && { isFeedback: true }),
            ...(sprint && { sprint }),
            // ...(sortType ? { sortType } : { sortType: "ASC" }),
            // sortBy: "boardIndex",
            rank: "ASC",
            ...(withDetails && { withDetails: true }),
            ...(viewType && { viewType }),
            ...(showEpic && { showEpic }),
            ...(summaryDate && { summaryDate }),
            ...(multiType && { multiType }),
          },
        };
      },
      providesTags: ["Bugs"],
    }),

    getBugDetailByBugId: builder.query({
      query: (params) => {
        if (params.withDetails) {
          return `/bug/${params.bugId}?withDetails=true`;
        }
        return `/bug/${params}`;
      },
      providesTags: (result, error, bugId) => [
        { type: "BugDetail", id: bugId },
      ],
    }),
    updateBugDetail: builder.mutation({
      query: (payload) => ({
        url: `/bug/${payload?.bugId}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: (result, error, { bugId }) => [
        { type: "BugDetail", id: bugId }, // Invalidate specific bug details
        "Bugs", // Also invalidate the bug list to update UI
      ],
    }),

    updateMultipleBugs: builder.mutation({
      query: (payload) => ({
        url: "/bugs",
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Bugs"],
    }),
    deleteBug: builder.mutation({
      query: (bugId) => ({
        url: `/bug/${bugId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { bugId }) => [
        { type: "BugDetail", id: bugId },
        "Bugs",
      ],
    }),
    deleteMultipleBugs: builder.mutation({
      query: (payload) => ({
        url: `/bug/bulk-delete`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bugs"],
    }),
    updateBugIndex: builder.mutation({
      query: (payload) => ({
        url: "/bug/indexes",
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Bugs"],
    }),
    getListOfProjects: builder.query({
      query: ({ page, size, searchName, filterBy, filterValue }) => ({
        url: "/projects",
        params: {
          ...(searchName && { searchName }),
          ...(page && { page: Number(page) }),
          ...(size && { size: Number(size) }),
          ...(filterBy && filterValue && { filterBy, filterValue }),
          ...(searchName && { partialSearch: true }),
        },
      }),
      providesTags: ["Project"],
    }),
    getProjectDashboardData: builder.query({
      query: () => ({
        url: "/project/dashboard",
      }),
      providesTags: ["Project"],
    }),
    getProjectById: builder.query({
      query: (projectId) => `/project/${projectId}`,
      providesTags: (result, error, projectId) => [
        { type: "Project", id: projectId },
      ],
    }),
    createProject: builder.mutation({
      query: (payload) => ({
        url: "/project",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Project"],
    }),
    updateProject: builder.mutation({
      query: (payload) => {
        const { projectId, ...body } = payload;
        return {
          url: `/project/${payload?.projectId}`,
          method: "PATCH",
          body: body,
        };
      },
      invalidatesTags: ["Project"],
    }),
    deleteProject: builder.mutation({
      query: (projectId) => ({
        url: `/project/${projectId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Project"],
    }),
    // Tags
    getListOfTags: builder.query({
      query: (params) => {
        // Support both string (projectId) and object ({ projectId, type }) formats
        if (typeof params === "string") {
          return params ? `/tags?project=${params}` : `/tags`;
        }
        const { projectId, type } = params || {};
        const queryParams = new URLSearchParams();
        if (projectId) queryParams.append("project", projectId);
        if (type) queryParams.append("type", type);
        const queryString = queryParams.toString();
        return queryString ? `/tags?${queryString}` : `/tags`;
      },
      providesTags: ["Tags"],
    }),
    getTagDetails: builder.query({
      query: (tagId) => `/tag/${tagId}`,
    }),
    createTag: builder.mutation({
      query: (payload) => ({
        url: "/tag",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Tags"],
    }),
    updateTag: builder.mutation({
      query: (payload) => {
        const { tagId, ...body } = payload;
        return {
          url: `/tag/${payload?.tagId}`,
          method: "PATCH",
          body: body,
        };
      },
      invalidatesTags: ["Tags"],
    }),
    deleteTag: builder.mutation({
      query: (tagId) => ({
        url: `/tag/${tagId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Tags"],
    }),
    // Status
    getDefaultStatus: builder.query({
      query: () => `/status/default`,
    }),
    getListOfStatus: builder.query({
      query: ({ projectId }) => {
        if (projectId) {
          return `/statuses?sortBy="createdAt"&sortType=ASC&project=${projectId}`;
        } else {
          return `/statuses?sortBy="createdAt"&sortType=ASC`;
        }
      },
      providesTags: ["Status"],
    }),
    getStatusDetails: builder.query({
      query: (statusId) => `/status/${statusId}`,
    }),
    createStatus: builder.mutation({
      query: (payload) => ({
        url: "/status",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Status"],
    }),
    updateStatus: builder.mutation({
      query: (payload) => ({
        url: `/status/${payload?.statusId}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Status"],
    }),
    deleteStatus: builder.mutation({
      query: (statusId) => ({
        url: `/status/${statusId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Status"],
    }),
    updateStatusIndex: builder.mutation({
      query: (payload) => ({
        url: `/status/indexes`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Status"],
    }),
    // Comments
    getCommentsByBugId: builder.query({
      query: ({ bugId }) => {
        let url = `/comments`;

        if (bugId) {
          url += `?itemId=${bugId}`;
        }

        return url;
      },
      providesTags: ["Comments"],
    }),
    createComment: builder.mutation({
      query: (payload) => ({
        url: "/comment",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Comments"],
    }),
    updateComment: builder.mutation({
      query: (payload) => ({
        url: `/comment/${payload?.commentId}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Comments"],
    }),
    deleteComment: builder.mutation({
      query: (commentId) => ({
        url: `/comment/${commentId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Comments"],
    }),
    // Public Comments
    createPublicComment: builder.mutation({
      query: (payload) => ({
        url: "/open-api/comment",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["PublicComments"],
    }),
    getPublicCommentsByBugId: builder.query({
      query: (bugId) => {
        return `/open-api/comments?itemId=${bugId}`;
      },
      providesTags: ["PublicComments"],
    }),
    deletePublicComment: builder.mutation({
      query: (commentId) => ({
        url: `/open-api/comment/${commentId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PublicComments"],
    }),
    // Filters
    getListOfFilters: builder.query({
      query: ({ page, size, project }) => ({
        url: "/bug-filter",
        params: {
          ...(page && { page: Number(page) }),
          ...(size && { size: Number(size) }),
          ...(project && { project }),
        },
      }),
      providesTags: ["Filters"],
    }),
    createFilter: builder.mutation({
      query: (payload) => ({
        url: "/bug-filter",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Filters"],
    }),
    getFilterById: builder.query({
      query: (filterId) => `/bug-filter/${filterId}`,
    }),
    updateFilter: builder.mutation({
      query: (payload) => ({
        url: `/bug-filter/${payload?.filterId}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["Filters"],
    }),
    deleteFilter: builder.mutation({
      query: (filterId) => ({
        url: `/bug-filter/${filterId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Filters"],
    }),
    getSprintList: builder.query({
      query: ({ projectId, page, limit, statuses }) => {
        let url = `/project/${projectId}/sprints`;
        if (statuses) {
          url += `?statuses=${statuses.join(",")}`;
        }
        // if (page) {
        //   url += `?page=${page}`;
        // }
        // if (limit) {
        //   url += `&limit=${limit}`;
        // }
        return url;
      },
      providesTags: ["Sprints"],
    }),
    getSprintById: builder.query({
      query: ({ sprintId }) => `/sprint/${sprintId}?withDetails=true`,
    }),
    getSprintByIdForWorkload: builder.query({
      query: ({ sprintId }) => `/sprint/${sprintId}?withAssignee=true`,
    }),
    createSprint: builder.mutation({
      query: (payload) => ({
        url: "/sprint",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Sprints"],
    }),
    updateSprint: builder.mutation({
      query: ({ sprintId, ...payload }) => ({
        url: `/sprint/${sprintId}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Sprints"],
    }),
    updateSprintStatus: builder.mutation({
      query: ({ sprintId, ...payload }) => ({
        url: `/sprint/${sprintId}/status`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Sprints"],
    }),
    deleteSprint: builder.mutation({
      query: (sprintId) => ({
        url: `/sprint/${sprintId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Sprints"],
    }),

    // Member / Client
    getListOfMembers: builder.query({
      query: ({ projectId, page, size, searchName }) =>
        `/project-members?project=${projectId}&page=${page}&size=${size}&searchName=${searchName}`,
      providesTags: ["ProjectMembers"],
    }),
    addMembersToProject: builder.mutation({
      query: (payload) => ({
        url: `/project-members`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["ProjectMembers"],
    }),
    updateMemberRole: builder.mutation({
      query: ({ memberId, ...payload }) => ({
        url: `/project-member/${memberId}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["ProjectMembers"],
    }),
    deleteMemberFromProject: builder.mutation({
      query: ({ memberId }) => ({
        url: `/project-member/${memberId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ProjectMembers"],
    }),

    // Bug Occurrences
    getBugOccurrences: builder.query({
      query: ({ projectId }) => `/project/${projectId}/bug-occurrences`,
      providesTags: ["BugOccurrences"],
    }),

    // Application
    getApplicationsByProjectId: builder.query({
      query: ({ projectId }) => `/project/${projectId}/applications`,
      providesTags: ["Applications"],
    }),
    createApplication: builder.mutation({
      query: ({ projectId, ...payload }) => ({
        url: `/project-application/${projectId}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Applications"],
    }),
    updateApplication: builder.mutation({
      query: ({ applicationId, ...payload }) => ({
        url: `/project-application/${applicationId}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Applications"],
    }),
    deleteApplication: builder.mutation({
      query: (applicationId) => ({
        url: `/project-application/${applicationId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Applications"],
    }),
    getApplicationDetails: builder.query({
      query: ({ applicationId }) => `/project-application/${applicationId}`,
      providesTags: ["Applications"],
    }),
    //Analysis
    getBugAnalysis: builder.query({
      query: ({ bugId, projectId, page, size }) => ({
        url: `/defect-analysis/project/${projectId}/bug/${bugId}`,
        params: {
          ...(page && { page: Number(page) }),
          ...(size && { size: Number(size) }),
        },
      }),
      providesTags: ["BugDetail"],
    }),
    updateDefectAnalysis: builder.mutation({
      query: ({ analysisId, ...body }) => ({
        url: `/defect-analysis/${analysisId}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["BugDetail"],
    }),
    // Feedback-widget
    getWidgetByProjectId: builder.query({
      query: ({ projectId }) => `/feedback-widget-config/${projectId}`,
      providesTags: ["FeedbackWidgets"],
    }),
    createFeedbackWidget: builder.mutation({
      query: (payload) => ({
        url: `/feedback-widget-config`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["FeedbackWidgets"],
    }),
    updateFeedbackWidget: builder.mutation({
      query: ({ feedbackWidgetId, ...payload }) => ({
        url: `/feedback-widget-config/${feedbackWidgetId}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["FeedbackWidgets"],
    }),
    deleteFeedbackWidget: builder.mutation({
      query: (feedbackWidgetId) => ({
        url: `/feedback-widget-config/${feedbackWidgetId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FeedbackWidgets"],
    }),
  }),
});

export const jiraTicketApi = createApi({
  reducerPath: "jiraTicketApi",
  baseQuery: baseQueryWithDecryption(import.meta.env.VITE_API_BASE_URL),
  // baseQuery: jiraBaseQuery,
  endpoints: (builder) => ({
    createJiraTicket: builder.mutation({
      query: (payload) => ({
        url: "/bug",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const jiraProjectApi = createApi({
  reducerPath: "jiraProjectApi",
  baseQuery: baseQueryWithDecryption(import.meta.env.VITE_API_BASE_URL),
  endpoints: (builder) => ({
    getProjectForDropDown: builder.query({
      query: () => "/jira/projects",
    }),
    getJiraProjectList: builder.query({
      query: () => "/project-configs",
    }),
    getProjectStatusLabels: builder.mutation({
      query: (body) => ({
        url: "/jira/project/status-labels",
        method: "POST",
        body,
      }),
    }),
    getJiraRequiredFields: builder.query({
      query: (projectId) => `/jira/project/${projectId}/required-fields`,
    }),
  }),
});

export const studioMgmtApi = createApi({
  reducerPath: "studioMgmtApi",
  baseQuery: baseQueryWithDecryption(import.meta.env.VITE_COMPANY_API_URL),
  // baseQuery: studioMgmtBaseQuery,
  tagTypes: ["CompanyConfig"],
  endpoints: (builder) => ({
    getConfigDetails: builder.query({
      query: () => "/company-config",
      providesTags: ["CompanyConfig"],
    }),
    createCompanyConfig: builder.mutation({
      query: (payload) => ({
        url: "/company-config",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["CompanyConfig"],
    }),
    updateCompanyConfig: builder.mutation({
      query: ({ payload, id }) => ({
        url: `/company-config/${id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["CompanyConfig"],
    }),
  }),
});

export const {
  // Dashboard
  useGetDashboardDataQuery,
  // Bug
  useCreateBugMutation,
  useGetListOfBugsQuery,
  useLazyGetListOfBugsQuery,
  useGetBugDetailByBugIdQuery,
  useLazyGetBugDetailByBugIdQuery,
  useUpdateBugDetailMutation,
  useDeleteBugMutation,
  useUpdateBugIndexMutation,
  useUpdateMultipleBugsMutation,
  useCreateLogMutation,
  useGetListOfLogsQuery,
  useLazyGetListOfLogsQuery,
  useUpdateWorkLogMutation,
  useDeleteMultipleBugsMutation,
  // Project
  useLazyGetListOfProjectsQuery,
  useGetListOfProjectsQuery,
  useGetProjectByIdQuery,
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useDeleteProjectMutation,
  useGetProjectDashboardDataQuery,
  // Tags
  useGetListOfTagsQuery,
  useGetTagDetailsQuery,
  useCreateTagMutation,
  useUpdateTagMutation,
  useDeleteTagMutation,
  // Status
  useGetDefaultStatusQuery,
  useGetListOfStatusQuery,
  useGetStatusDetailsQuery,
  useCreateStatusMutation,
  useUpdateStatusMutation,
  useDeleteStatusMutation,
  useUpdateStatusIndexMutation,
  // Comments
  useGetCommentsByBugIdQuery,
  useCreateCommentMutation,
  useUpdateCommentMutation,
  useDeleteCommentMutation,
  // Public Comments
  useGetPublicCommentsByBugIdQuery,
  useCreatePublicCommentMutation,
  useDeletePublicCommentMutation,
  // Filters
  useGetListOfFiltersQuery,
  useGetFilterByIdQuery,
  useCreateFilterMutation,
  useUpdateFilterMutation,
  useDeleteFilterMutation,
  //Sprint
  useGetSprintListQuery,
  useGetSprintByIdQuery,
  useLazyGetSprintByIdQuery,
  useCreateSprintMutation,
  useUpdateSprintMutation,
  useDeleteSprintMutation,
  useUpdateSprintStatusMutation,
  useGetSprintByIdForWorkloadQuery,
  // Member / Client
  useGetListOfMembersQuery,
  useAddMembersToProjectMutation,
  useUpdateMemberRoleMutation,
  useDeleteMemberFromProjectMutation,

  // Bug Occurrences
  useGetBugOccurrencesQuery,

  // Application
  useGetApplicationsByProjectIdQuery,
  useCreateApplicationMutation,
  useUpdateApplicationMutation,
  useDeleteApplicationMutation,
  useGetApplicationDetailsQuery,

  // Analysis
  useGetBugAnalysisQuery,
  useUpdateDefectAnalysisMutation,

  // Feedback-widget
  useGetWidgetByProjectIdQuery,
  useCreateFeedbackWidgetMutation,
  useUpdateFeedbackWidgetMutation,
  useDeleteFeedbackWidgetMutation,
} = supportMgmtApi;

export const { useCreateJiraTicketMutation } = jiraTicketApi;

export const {
  useGetProjectForDropDownQuery,
  useGetProjectStatusLabelsMutation,
  useGetJiraProjectListQuery,
  useGetJiraRequiredFieldsQuery,
  useLazyGetJiraRequiredFieldsQuery,
} = jiraProjectApi;

export const {
  useGetConfigDetailsQuery,
  useCreateCompanyConfigMutation,
  useUpdateCompanyConfigMutation,
} = studioMgmtApi;
